'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_MuiExtensions$() {
}
export { $c_Lmealorama_components_MuiExtensions$ as $c_Lmealorama_components_MuiExtensions$ };
$p = $c_Lmealorama_components_MuiExtensions$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_MuiExtensions$;
/** @constructor */
function $h_Lmealorama_components_MuiExtensions$() {
}
export { $h_Lmealorama_components_MuiExtensions$ as $h_Lmealorama_components_MuiExtensions$ };
$h_Lmealorama_components_MuiExtensions$.prototype = $p;
$p.hF = (function(target) {
  return target.value;
});
$p.o6 = (function(builder, value) {
  builder.bH()[1].type = value.lm;
  return builder;
});
$p.aFX = (function(builder, min, max) {
  var _2 = ({
    "min": min,
    "max": max
  });
  var value$proxy6 = ({
    "htmlInput": _2
  });
  builder.bH()[1].slotProps = value$proxy6;
  return builder;
});
var $d_Lmealorama_components_MuiExtensions$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_MuiExtensions$, "mealorama.components.MuiExtensions$", ({
  HW: 1
}));
export { $d_Lmealorama_components_MuiExtensions$ as $d_Lmealorama_components_MuiExtensions$ };
var $n_Lmealorama_components_MuiExtensions$;
function $m_Lmealorama_components_MuiExtensions$() {
  if ((!$n_Lmealorama_components_MuiExtensions$)) {
    $n_Lmealorama_components_MuiExtensions$ = new $c_Lmealorama_components_MuiExtensions$();
  }
  return $n_Lmealorama_components_MuiExtensions$;
}
export { $m_Lmealorama_components_MuiExtensions$ as $m_Lmealorama_components_MuiExtensions$ };
//# sourceMappingURL=mealorama.components.-Mui-Extensions$.js.map
